<template>
<div>
  <div class="introduction-container">

    <div class="introduction-box1" @mouseenter="showBox1" @mouseleave="hideBox1">
      <div v-if="isShowboxone">
      <div class="introduction-box1-text1">企业信息化服务</div>
      <div class="introduction-box1-text2">Enterprise information</div>
      </div>
      <div v-else>
        <div class="introduction-text1">企业信息化服务</div>
        <div  class="introduction-text2">通过信息化建设，让企业拥有便捷管理、快速响应等能力，为企业开源节流提供支撑服务</div>
        <img src="../../../assets/images/矩形 95.png" alt="" class="introduction-background">
      </div>
      <div class="introduction-box1-text3"></div>
    </div>

    <div class="introduction-box2" @mouseenter="showBox2" @mouseleave="hideBox2" >
      <div v-if="isShowboxtwo">
      <div class="introduction-box2-text1">互联网产品与运营</div>
      <div class="introduction-box2-text2">Internet product</div>
      </div>
      <div v-else>
        <div class="introduction-text3">互联网产品研发与运营</div>
        <div  class="introduction-text4">拥抱互联网、物联网技术，整合多端资源能力，连接用户并提供更加便捷的服务</div>
        <img src="../../../assets/images/矩形 95.png" alt="" class="introduction-background">
      </div>
      <div class="introduction-box2-text3"></div>
    </div>

    <div class="introduction-box3">
      <div class="introduction-box3-text1"></div>
      <div class="introduction-box3-text2">安徽中培智慧信息科技有限公司成立于2022年8月，专注于信息化科技创新服务。公司是一家专注专业从事职业技能培训、职业技能考务、职业水平评价的综合类教育服务企业。公司一直专注于各种软硬件的开发，全力打造互联网+新型系统。</div>
      <div class="introduction-box3-text3"></div>
      <div class="introduction-box3-text4"> 自成立以来，凭借专业的技术能力和优质的售后服务获得客户的一致好评。目前业务已覆盖合肥、芜湖、六安、淮南等地区。</div>
    </div>
  </div>
  <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../../componets/footer/Footer.vue"
export default {
  name:"Introduction",
  data() {
    return {
      isShowboxone: true,
      isShowboxtwo: true,
    }
  },
  created() {
    const num = 0
    this.$emit("receviceData",num)
  },
  methods: {
    showBox1() {
      this.isShowboxone = false
    },
    hideBox1() {
      this.isShowboxone = true
    },
    showBox2() {
      this.isShowboxtwo = false
    },
    hideBox2() {
      this.isShowboxtwo = true
    }
  },
  components: {
    Footer,
  }
}
</script>

<style lang="less" scoped>
.introduction-container {
  width: 12rem;
  height: 7.8rem;
  margin: 0 3.6rem;
  margin-bottom: 0.83rem;
  position: relative;
}
//第一个文本框
.introduction-box1 {
  width: 5.9rem;
  height: 3.8rem;
  background-image: url("../../../assets/companyimages/矩形 87.png");
  background-repeat: no-repeat;
  background-size: 5.9rem 3.8rem;
  position: absolute;
}
.introduction-box1-text1 {
  width: 2.66rem;
  height: 0.56rem;
  font-size: 0.38rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.56rem;
  color: #FFFFFF;
  position: absolute;
  top: 0.48rem;
  left: 0.5rem;
}
.introduction-box1-text2 {
  width: 3.5rem;
  height: 0.35rem;
  font-size: 0.28rem;
  font-family: DIN-BlackItalic;
  font-weight: 400;
  line-height: 0.35rem;
  text-align: left;
  color: #FFFFFF;
  opacity: 0.5;
  position: absolute;
  top: 1.14rem;
  left: 0.5rem;
}
.introduction-box1-text3 {
  width: 2.01rem;
  height: 1.86rem;
  background-image: url("../../../assets/companyimages/组 126.png");
  background-repeat: no-repeat;
  background-size: 2.01rem 1.86rem;
  position: absolute;
  top: 1.71rem;
  left: 3.4rem;
}
//隐藏的内容样式
.introduction-text1 {
  width: 2.52rem;
  height: 0.54rem;
  font-size: 0.36rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.54rem;
  color: #FFFFFF;
  position: absolute;
  top: 1.14rem;
  left: 1.69rem;
   z-index: 99;
}
.introduction-text2 {
  width: 4.7rem;
  height: 0.78rem;
  font-size: 0.22rem;
  text-align: left;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0.44rem;
  color: #FFFFFF;
  position: absolute;
  top: 1.88rem;
  left: 0.6rem;
  z-index: 99;
}
.introduction-background {
  width: 5.9rem;
  height: 3.8rem;
  display: block;
  position: absolute;
  top: 0;
  z-index: 88;
}
//第二个文本框
.introduction-box2 {
  width: 5.9rem;
  height: 3.8rem;
  background-image: url("../../../assets/companyimages/矩形 89.png");
  background-repeat: no-repeat;
  background-size: 5.9rem 3.8rem;
  position: absolute;
  top: 4rem;
}
.introduction-box2-text1 {
  width: 3.8rem;
  height: 0.56rem;
  font-size: 0.38rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.56rem;
  color: #FFFFFF;
  position: absolute;
  top: 0.39rem;
}
.introduction-box2-text2 {
  width: 3rem;
  height: 0.35rem;
  font-size: 0.28rem;
  font-family: DIN-BlackItalic;
  font-weight: 400;
  line-height: 0.35rem;
  text-align: left;
  color: #FFFFFF;
  opacity: 0.5;
  position: absolute;
  top: 1.05rem;
  left: 0.5rem;
}
.introduction-box2-text3 {
  width: 1.93rem;
  height: 1.92rem;
  background-image: url("../../../assets/companyimages/组 127.png");
  background-repeat: no-repeat;
  background-size: 1.93rem 1.92rem;
  position: absolute;
  top: 1.6rem;
  left: 3.438rem;
}
//第二个隐藏的内容样式
.introduction-text3 {
  width: 3.6rem;
  height: 0.54rem;
  font-size: 0.36rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.54rem;
  color: #FFFFFF;
  position: absolute;
  top: 1.14rem;
  left: 1.15rem;
  z-index: 99;
}
.introduction-text4 {
  width: 4.7rem;
  height: 0.79rem;
  font-size: 0.22rem;
  text-align: left;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0.44rem;
  color: #FFFFFF;
  position: absolute;
  top: 1.88rem;
  left: 0.6rem;
  z-index: 99;
}
//
//第三个文本框
.introduction-box3 {
  width: 5.9rem;
  height: 7.8rem;
  background-image: url("../../../assets/companyimages/矩形 88.png");
  background-repeat: no-repeat;
  background-size: 5.9rem 7.8rem;
  position: absolute;
  left: 6.1rem;
}
.introduction-box3-text1 {
  width: 1.85rem;
  height: 0.37rem;
  //background-image: url("../../../assets/companyimages/组 121.png");
  background-size:1.85rem 0.37rem;
  position: absolute;
  top: 0.58rem;
  left: 0.55rem;
}
.introduction-box3-text2{
  width: 4.7rem;
  font-size: 0.22rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0.55rem;
  text-align: left;
  text-indent: 2em;
  color: #FFFFFF;
  position: absolute;
  top:1.53rem;
  left: 0.6rem;
}
.introduction-box3-text3 {
  width: 1.96rem;
  height: 1.91rem;
  background-image: url("../../../assets/companyimages/组 128.png");
  background-repeat: no-repeat;
  background-size: 1.96rem 1.91rem;
  position: absolute;
  top: 5.6rem;
  left: 3.47rem;
}
.introduction-box3-text4{
  width: 4.7rem;
  font-size: 0.22rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  line-height: 0.55rem;
  text-align: left;
  text-indent: 2em;
  color: #FFFFFF;
  position: absolute;
  bottom:1.35rem;
  left: 0.6rem;
}
</style>
